"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
exports.default = ({ colour = "currentColor" }) => {
    return (react_1.default.createElement("path", { d: "M10.6798 21.3734L9.02693 28.7968C8.85731 29.5586 9.51917 30.2186 10.1646 29.9314L30.4595 20.8984C31.1802 20.5777 31.1802 19.4223 30.4595 19.1016L10.1646 10.0686C9.51917 9.78136 8.85731 10.4414 9.02693 11.2032L10.6798 18.6266L21.6666 20L10.6798 21.3734Z", fill: colour }));
};
//# sourceMappingURL=Send.js.map